import React, { useEffect } from "react";
import classes from "./Navbar.module.scss";
import { E2Data } from "../../lib/ddd/ddd";


const Notifications = ({ notifications = [], onItemClick }) => {
  //const list = notifications?.result?.data || [];
  const list = (notifications?.result?.data || []).slice(0, 10);

  if (!list.length) {
    return (
      <div className={`${classes.empty3} p-3 text-center`}>
        There are no unread notifications.
      </div>
    );
  }

  const truncate = (text, max = 70) => {
    if (!text) return "";
    return text.length > max ? text.slice(0, max) + "…" : text;
  };

  return (
    <div className={classes.wrapper3}>
      {list.map((n, idx) => (
        <div
          key={idx}
          className={`${classes.item3} ${classes[n.Type+3] || classes["None3"]}`}
          onClick={() => onItemClick?.(n)}
          style={n.LongDescription ? {}: {cursor : "default"}}
        >
          <div className={classes.rowTop3}>
            <span className={classes.shortText3}>{truncate(n.Short)}</span>
          </div>

          {n.From && (
            <div className={classes.from3}>From: {n.From}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Notifications;


/* const Notifications = ({notifications}) => {
  //notifications?.result?.data || []
  return (
    <div
      className={`${classes.dropdown} d-flex justify-content-center align-items-center text-center p-4`}
    >
      There are no unread notifications.
    </div>
  );
};

export default Notifications; */
